import React from 'react';

// Standalone Footer for JoSmart Academy (detached app)
export default function Footer() {
  return (
    <footer
      data-testid="academy-footer"
      className="w-full bg-gray-900 text-gray-300 mt-16"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid gap-8 md:grid-cols-3">
        <div>
          <h3 className="text-white font-semibold mb-2">JoSmart Academy</h3>
          <p className="text-sm text-gray-400">
            Plateforme e-learning multi-formations : anglais interactif, création de sites web, coach interactif.
          </p>
        </div>
        <div>
          <h3 className="text-white font-semibold mb-2">Écosystème JoSmartTech</h3>
          <ul className="space-y-1 text-sm">
            <li>
              <a
                href="https://josmartech.net"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white"
                data-testid="footer-main-site-link"
              >
                Site principal josmartech.net
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-semibold mb-2">Contact</h3>
          <ul className="space-y-1 text-sm text-gray-400">
            <li>support.josmartech@gmail.com</li>
            <li>WhatsApp : +1 (431) 334-5083</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 py-4 text-center text-xs text-gray-500">
          © {new Date().getFullYear()} JoSmartTech — JoSmart Academy. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
}
